import React from 'react';
import { motion } from 'framer-motion';

interface Option {
  value: any;
  label: string;
}

interface OptionGroupProps {
  title: string;
  icon?: React.ReactNode;
  options: Option[];
  selectedValue: any;
  onChange: (value: any) => void;
}

export const OptionGroup: React.FC<OptionGroupProps> = ({
  title,
  icon,
  options,
  selectedValue,
  onChange,
}) => {
  return (
    <div className="bg-white rounded-lg p-4 shadow-sm">
      <h4 className="font-medium mb-4 flex items-center gap-2">
        {icon}
        {title}
      </h4>
      <div className="space-y-2">
        {options.map(({ value, label }) => (
          <motion.button
            key={value}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onChange(value)}
            className={`w-full py-3 px-4 rounded-lg transition-all text-left ${
              selectedValue === value
                ? 'bg-orange-500 text-white shadow-md'
                : 'bg-orange-100 text-gray-700 hover:bg-orange-200'
            }`}
          >
            {label}
          </motion.button>
        ))}
      </div>
    </div>
  );
};